<script setup lang="ts">
import { computed, ComputedRef, onMounted, ref, Ref, watch } from 'vue'
import { useFilter } from '@/composables/filters/filters'
import DocumentQueryList from '@/views/DocumentQueryList.vue'
import ArtifactListPicker from '@/components/ArtifactListPicker.vue'
import ArtifactDisplay from '@/components/artifacts/ArtifactDisplay.vue'
import { useArtifactStore } from '@/store/artifacts'
const artifactFilter = useFilter('artifact')
const artifactId = defineModel<string>()
const artifactType: Ref<string | null> = ref(null)
const availableArtifactTypes: Ref<string[]> = ref([])
const queryArtifacts = useArtifactStore().queryArtifacts
const query: Ref<typeof DocumentQueryList | null> = ref(null)
const presetFilters: ComputedRef<{ key: string; operator: string; value: string | number | boolean }[]> = computed(() => {
  const filters = []
  if (artifactType.value !== null) {
    filters.push({
      key: 'type',
      operator: '==',
      value: artifactType.value,
    })
  }
  return filters
})
watch(
  () => presetFilters.value,
  () => {
    query.value?.parseQueryParams()
  },
  { immediate: true, deep: true }
)
onMounted(() => {
  availableArtifactTypes.value = artifactFilter.getOptions('type')
})
</script>

<template>
  <v-container max-height="100%">
    <h3 class="mb-2">{{ $t('artifact.picker.enter_artifact_id') }}</h3>
    <v-text-field
      v-model="artifactId"
      variant="outlined"
      :label="$t('artifact.picker.artifact_id')"
    ></v-text-field>

    <ArtifactDisplay
      v-if="artifactId"
      :artifact-id="artifactId"
    ></ArtifactDisplay>

    <v-row class="justify-center my-4">
      <v-col cols="auto"
        ><h4>{{ $t('general_interface.or') }}</h4></v-col
      >
    </v-row>
    <h3 class="mb-2">{{ $t('artifact.picker.select_artifact') }}</h3>
    <DocumentQueryList
      ref="query"
      :enable-query-params="false"
      query-type="artifact"
      unique-document-identifier="artifactId"
      :query-function="queryArtifacts"
      :preset-order="{ sortBy: 'timestamp', direction: 'desc' }"
      :preset-filters="presetFilters"
      :auto-load="true"
      :hide-items-per-page="true"
      :preset-items-per-page="10"
    >
      <template #list="listProps">
        <ArtifactListPicker
          v-model="artifactId"
          :artifacts="listProps.documents"
        ></ArtifactListPicker>
      </template>
    </DocumentQueryList>
  </v-container>
</template>

<style scoped></style>
